module.exports = __webpack_public_path__ + "img/half-homemade-brownies.227d3048.jpg";